import React from 'react';
import { observer } from 'mobx-react';

import Section from '../uic/Section';
import { List, Row, Label, Value } from '../uic/list';
import session from '../session';

const LicenseHome = observer(
    class extends React.Component {
        state = {
            Image_Name: 'N/A',
            License_ID: 'N/A',
            Image_Features: 'N/A',
            Issue_Date: 'N/A',
            Expire_Date: 'N/A',
            Signature: 'N/A',
            Status: 'N/A'
        };

        load = async () => {
            try {
                const cgicheck = await session.realm.fetch(
                    '/cgi/licensecheck.cgi'
                );
                var objcheck = JSON.parse(cgicheck);

                if (objcheck.hasOwnProperty('license')) {
                    this.setState({ Status: objcheck.license });
                } else {
                    this.setState({ Status: 'Error' });
                }
            } catch (err) {
                console.error('LicenseHome:' + err);
            }
        };

        componentDidMount() {
            this._timer = setInterval(this.load, 2000);
        }

        componentWillUnmount() {
            if (this._timer) {
                clearInterval(this._timer);
            }
        }

        render() {
            return (
                <Section title="License">
                    <List>
                        <Row>
                            <Label>Status</Label>
                            <Value>{this.state.Status.toUpperCase()}</Value>
                        </Row>
                    </List>
                </Section>
            );
        }
    }
);

export default LicenseHome;



// WEBPACK FOOTER //
// ./src/sections/LicenseHome.js